<div id="start" fxLayout="column">
  <div id="start-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="start-form"
      [@animate]="{ value: '*', params: { duration: '200ms', y: '100px' } }">
      <div fxLayout="row wrap">
        <div fxlayout="row wrap" fxflex="50" class="logo-padding">
          <div class="logo">
            <img
              src="../../../assets/images/logos/logo_eduid.svg"
              alt="Logo EDUID" />
          </div>
          <div class="title" fxLayoutAlign="center center">
            {{ 'START.DOCTITLE' | translate }}
          </div>
          <button
            mat-raised-button
            color="accent"
            class="submit-button"
            aria-label="LOG IN"
            (click)="RedirectToFaq()">
            {{ 'START.DOCBTN' | translate }}
          </button>
        </div>
        <div class="startbox startbox-padding" fxlayout="row wrap" fxflex="50">
          <form name="startForm" [formGroup]="startForm" novalidate>
            <div class="title" fxLayoutAlign="center center">
              {{ 'GENERAL.TITLE.ACTIVATE' | translate }}
            </div>
            <mat-form-field class="mat-username">
              <mat-label>{{
                'USERS.SINGLE.INFO.USERNAME' | translate
              }}</mat-label>
              <input
                autoComplete="on"
                matInput
                formControlName="username"
                [maxLength]="maxlength" />
              <mat-error>
                {{ 'ERROR.USERNAME' | translate }}
              </mat-error>
              @if (startForm.get('username')?.hasError('maxlength')) {
                <mat-error> trop long </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="mat-code">
              <mat-label>{{ 'START.ACTIVATIONCODE' | translate }}</mat-label>
              <input
                autoComplete="on"
                matInput
                formControlName="activationCode"
                [maxLength]="maxlength" />
              <mat-error>
                {{ 'ERROR.CODE' | translate }}
              </mat-error>
              @if (startForm.get('username')?.hasError('maxlength')) {
                <mat-error> trop long </mat-error>
              }
            </mat-form-field>

            <button
              mat-raised-button
              color="accent"
              class="submit-button"
              aria-label="LOG IN"
              (click)="start()"
              [disabled]="startForm.invalid || isBusy">
              {{ 'START.ACTIVATEBUTTON' | translate }}
            </button>
            @if (isBusy) {
              <div fxLayout="row" fxLayoutAlign="center center">
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              </div>
            }
          </form>
          @if (starterror) {
            <div class="message-box error">
              <app-error-message [error]="error.error" />
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
